//#region types
import { DisplayType } from "models/enums/style";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { DocumentationLogCreateLinkProps } from "models/propTypes/advisorPropTypes";
//#endregion
//#region components
import { ActionLinkButton, Icon } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const DocumentationLogCreateLink: React.FC<DocumentationLogCreateLinkProps> = (props) => {
  const onclick = () => {
    props.onDocumentationLogCreate && props.onDocumentationLogCreate();
  };

  return (
    <ActionLinkButton
      className={clsx(cssExports.seeMoreLink)}
      onClick={onclick}
      startIcon={<Icon icon={IconDefinitionConstants.WPlus} displayType={DisplayType.Info} />}
    >
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Add)}
    </ActionLinkButton>
  );
};

export default DocumentationLogCreateLink;
